import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Tabs } from "../../model/tabs.model";
import { MatTabsModule } from "@angular/material/tabs";
@Component({
  selector: "app-common-tabs",
  standalone: true,
  imports: [CommonModule, MatTabsModule],
  templateUrl: "./common-tabs.component.html",
  styleUrls: ["./common-tabs.component.scss"],
})
export class CommonTabsComponent {
  @Input() tabs!: Tabs[];
}
